export default __webpack_public_path__ + "static/media/cern-extrabold.6fbfe870.woff2";